var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 36.0003V34.667C10.6665 21.4137 20.2185 10.667 31.9998 10.667C43.7812 10.667 53.3332 21.4137 53.3332 34.667V36.0003",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 46.5037V41.4983C5.33368 40.309 5.73137 39.1539 6.46338 38.2166C7.19538 37.2792 8.21969 36.6134 9.3735 36.325L10.6668 35.9997L14.0108 35.1623C14.2468 35.1032 14.4931 35.0985 14.7311 35.1489C14.9691 35.1992 15.1925 35.3031 15.3843 35.4528C15.5761 35.6024 15.7313 35.7938 15.838 36.0124C15.9447 36.231 16.0002 36.4711 16.0002 36.7143V51.285C16.0002 51.5283 15.9447 51.7683 15.838 51.987C15.7313 52.2056 15.5761 52.397 15.3843 52.5466C15.1925 52.6962 14.9691 52.8002 14.7311 52.8505C14.4931 52.9008 14.2468 52.8962 14.0108 52.837L9.37083 51.677C8.21751 51.3881 7.19381 50.7221 6.46232 49.7848C5.73084 48.8475 5.33353 47.6926 5.3335 46.5037V46.5037ZM58.6668 46.5037V41.4983C58.6667 40.309 58.269 39.1539 57.537 38.2166C56.8049 37.2792 55.7806 36.6134 54.6268 36.325L53.3335 35.9997L49.9868 35.1623C49.7511 35.1036 49.505 35.0994 49.2673 35.1499C49.0297 35.2005 48.8066 35.3045 48.6152 35.4541C48.4237 35.6036 48.2688 35.7949 48.1622 36.0132C48.0557 36.2316 48.0003 36.4714 48.0002 36.7143V51.285C48.0003 51.528 48.0557 51.7678 48.1622 51.9861C48.2688 52.2045 48.4237 52.3957 48.6152 52.5453C48.8066 52.6949 49.0297 52.7989 49.2673 52.8494C49.505 52.9 49.7511 52.8957 49.9868 52.837L54.6268 51.677C55.7806 51.3886 56.8049 50.7228 57.537 49.7855C58.269 48.8481 58.6667 47.693 58.6668 46.5037Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.92fa0e0c87dad3746d39b697fd007ffa.svg";
export { ForwardRef as ReactComponent };